// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 768px)";
var _4 = "paper-28mZE";
var _5 = "header-DfotD";
var _6 = "content-3GsvF";
var _7 = "content__text-12A00";
var _8 = "content__text_hidden-YQxq_";
var _9 = "content__error-P150Z";
var _a = "buttons-XOY5b";
var _b = "closeButton-3i3lU";
var _c = "scrollBody-1B9lZ";
export { _1 as "__esModule", _2 as "mobile", _3 as "tabletMiddle", _4 as "paper", _5 as "header", _6 as "content", _7 as "content__text", _8 as "content__text_hidden", _9 as "content__error", _a as "buttons", _b as "closeButton", _c as "scrollBody" }
export default { "__esModule": _1, "mobile": _2, "tabletMiddle": _3, "paper": _4, "header": _5, "content": _6, "content__text": _7, "content__text_hidden": _8, "content__error": _9, "buttons": _a, "closeButton": _b, "scrollBody": _c }
